<template>
  <div id="app" class="inter-regular">
    <lco-loader v-if="isActive" />
    <lco-message
      v-if="isMessage"
      :message="message"
      :backgroundColor="backgroundColor"
      :leftalign="leftalign"
      :minwidth="minwidth"
      :topalign="topalign"
      :snackbarClass="snackbarClass"
    />
    <router-view />
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import firebase from "@/components/description/firebaseIssue";
export default {
  name: "app",
  data() {
    return {
      isActive: false,
      isMessage: false,
      message: "",
      backgroundColor: "",
      leftalign: 0,
      minwidth: 0,
      topalign: 0,
      snackbarClass: "snackbar"
    };
  },
  watch: {
    $route() {
      this.checkStatusRoute();
    },
    getsideNav (data) {
      if (data) {
        this.topalign = 42;
        this.leftalign = 15.4;
        this.minwidth = 86;
      } else {
        this.topalign = 42;
        this.leftalign = 5;
        this.minwidth = 95;
      }
    }
  },
  computed: {
    ...mapGetters(["getMode", "getSubuserInfo", "getSideNavInfo", 'getsideNav', 'getUniqueCustomerId']),
    ...mapState(["version"])
  },
  methods: {
    ...mapActions(["actGetUserInfo", 'actGetSubuserInfo']),
    ...mapMutations(["setUserInfo"]),
    checkStatusRoute() {
      console.log(this.$route.name);
      if (
        this.$route.name !== "register" &&
        this.$route.name !== "support" &&
        this.$route.name !== "helpcenter" &&
        this.$route.name !== "privacy" &&
        this.$route.name !== "covid19awareness" &&
        this.$route.name !== "covid19awarenessid" &&
        this.$route.name !== "maintenance" &&
        this.$route.name !== "newportal" &&
        this.$route.name !== "maintenancelogin" &&
        this.$route.name !== "termsforservices" &&
        this.$route.name !== "paymentstatuscheck"
      ) {
        if (!localStorage.getItem("lcoUser")) {
          this.$router.push({ name: "login" });
        }
      }
    },
    updatedUser() {
      let user = JSON.parse(localStorage.getItem("subUser"))
      this.actGetUserInfo().then(
          response => {
            if (user) {
              if (user.lcosubuserid) {
                this.getSubUserData(response.credit)
              } else {
                this.setUserInfo(response)
                localStorage.setItem("lcoUser", JSON.stringify(response))
                if (this.getMode == "development") {
                  this.setUserInfo(JSON.parse(localStorage.getItem("lcoUser")));
                }
              }
            } else {
              localStorage.removeItem("lcoUser");
              localStorage.removeItem("subUser");
              localStorage.removeItem("showDashboardPopup");
              this.$router.push({ name: "login" });
            }
          },
          error => {
            localStorage.removeItem("lcoUser");
            localStorage.removeItem("subUser");
            localStorage.removeItem("showDashboardPopup");
            this.$router.push({ name: "login" });
          }
      );
    },
    getSubUserData (credit) {
      let data = {}
      let user = JSON.parse(localStorage.getItem("subUser"))
        data.subuserid = user.lcosubuserid
        this.actGetUserInfo(data).then(
          response => {
            response.credit = credit
            this.setUserInfo(response);
            localStorage.setItem("lcoUser", JSON.stringify(response))
            localStorage.setItem("subUser", JSON.stringify(response))
            if (this.getMode == "development") {
              this.setUserInfo(JSON.parse(localStorage.getItem("lcoUser")));
            }
          },
          error => {
            localStorage.removeItem("lcoUser");
            localStorage.removeItem("subUser");
            this.$router.push({ name: "login" });
          }
        );
    },
    checkConnection() {
      window.addEventListener("offline", () => {
        this.isMessage = true;
        this.message = "Please Check Your Internet Connection";
        this.backgroundColor = "#EC4C47";
        this.minwidth = "100";
        this.snackbarClass = "login-snackbar";
        setTimeout(() => {
          this.isMessage = false;
        }, 3000);
      });
    },
    messagesSnackbar() {
      eventBus.$on("lco-message", state => {
        console.log("entered app.vue", state);
        this.message = state.message;
        console.log("message ", this.message);
        if (!this.message) {
          return;
        }
        console.log(typeof this.message);
        if (typeof this.message == "object") {
          this.message = "No valid session exist";
          return;
        }

        if (!state.backgroundColor) {
          this.backgroundColor = "#EC4C47";
        } else {
          this.backgroundColor = "#47B881";
        }
        this.isMessage = state.status;

        if (!state.leftalign) {
          this.leftalign = 15;
        } else {
          this.leftalign = state.leftalign;
        }

        if (!state.minwidth) {
          this.minwidth = 85;
        } else {
          this.minwidth = state.minwidth;
        }

        if (this.message == "No valid session exist") {
          localStorage.removeItem("lcoUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          this.topalign = 0;
          this.leftalign = 0;
          this.minwidth = 100;
          this.snackbarClass = "login-snackbar";
          this.$router.push({ name: "login" });
        }
        if (this.message == "User is not valid.") {
          this.$router.push({ name: "login" });
          localStorage.removeItem("lcoUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          this.topalign = 0;
          this.leftalign = 0;
          this.minwidth = 100;
          this.snackbarClass = "login-snackbar";
        }
        if (this.message == "Unauthorized") {
          localStorage.removeItem("lcoUser");
          localStorage.removeItem("subUser");
          localStorage.removeItem("token");
          localStorage.removeItem("showDashboardPopup");
          this.topalign = 0;
          this.leftalign = 0;
          this.minwidth = 100;
          this.snackbarClass = "login-snackbar";
          this.message = "No valid session exist";
        }

        if (window.matchMedia("(max-width: 1024px)").matches) {
          this.leftalign = 0;
          this.minwidth = 100;
          this.rightalign = 0;
        } else {
          this.rightalign = "-6px";
        }

        console.log("message ", this.message);
        if (this.leftalign == 15.4) {
          this.leftalign = 14.5;
          this.minwidth = 86;
        }
        console.log("route name ", this.$route.name);

        if (window.matchMedia("(min-width: 1025px)").matches) {
          if (
            this.$route.name == "login" ||
            this.$route.name == "register" ||
            this.$route.name == "paymentstatuscheck" ||
            this.$route.name == "contactverify" ||
            this.message == "No valid session exist"
          ) {
            console.log("entered");
            this.topalign = 0;
            this.leftalign = 0;
            this.minwidth = 100;
            this.snackbarClass = "login-snackbar";
          } else if (
            this.$route.name == "dashboard" ||
            this.$route.name == "alert" ||
            this.$route.name == "quiz" ||
            this.$route.name == "download" ||
            this.$route.name == "checkout" ||
            this.$route.name == "topup" ||
            this.$route.name == "subuser" ||
            this.$route.name == "generatenewinvoice" ||
            this.$route.name == "invoicecheckout"
          ) {
            this.topalign = 42;
            this.leftalign = 5;
            this.minwidth = 95;
            this.snackbarClass = "snackbar";
          } else {
            if (this.getsideNav) {
              this.topalign = 42;
              this.leftalign = 15.4;
              this.minwidth = 86;
              this.snackbarClass = "snackbar";
            } else {
              this.topalign = 42;
              this.leftalign = 5;
              this.minwidth = 95;
              this.snackbarClass = "snackbar";
            }
          }
        } else {
          this.topalign = 0;
          this.leftalign = 0;
          this.minwidth = 100;
          this.snackbarClass = "login-snackbar";
        }
        if (this.getUniqueCustomerId) {
          this.topalign = 42;
          this.leftalign = 2.5;
          this.minwidth = 95;
          this.snackbarClass = "snackbar";
        }
        setTimeout(() => {
          this.isMessage = false;
        }, 3000);
      });
    },
    checkoutMessage () {
      eventBus.$on("checkout-message", state => {
        if (!state.backgroundColor) {
          this.backgroundColor = "#EC4C47";
        } else {
          this.backgroundColor = "#47B881";
        }
        this.isMessage = true;
        this.message = state.message
        this.topalign = 42;
        this.leftalign = 15.4;
        this.minwidth = 86;
        this.snackbarClass = "snackbar";
        setTimeout(() => {
          this.isMessage = false;
        }, 3000);
      });
    },
    hideMessage () {
      eventBus.$on("hide-message", state => {
        this.isMessage = state;
      });
    },
    events() {
      eventBus.$on("lco-loader", state => {
        this.isActive = state;
      });
      eventBus.$on("updateLocalStorage", state => {
        this.updatedUser();
      });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("lcoUser"))) {
      this.updatedUser();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("lcoUser")) {
      next();
    } else {
      next({ name: "login" });
    }
  },
  created() {
    if(this.getMode != "development") {
      console.log = function() {}
    }
    this.events()
    this.messagesSnackbar()
    this.checkoutMessage()
    this.hideMessage()
    console.log("version:::", this.version)
  },
  beforeDestroy() {
    eventBus.$off("lco-loader");
    eventBus.$off("lco-message");
    eventBus.$off("checkout-message");
    eventBus.$off("hide-message");
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue